var t = {
    control: "select-control",
    arrowButton: "select-arrow-button",
    optionsListPopup: "select--options--list-popup",
    optionsListPopupOption: "select--options--list-popup--option",
    clearButton: "select-clear-button",
    popupMenu: "popup-menu",
    variable: "variable-select",
    variableIcon: "variable-icon",
    card: "input-card"
  },
  o = {
    controlWrapper: "select__control-wrapper"
  },
  e = {
    dataAttributes: t,
    classNames: o
  };
export { e as selectSelectors };